/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react'
import { 
  FiVideo, 
  FiUser, 
  FiTag, 
  FiCalendar, 
  FiClock, 
  FiUsers,
  FiRefreshCw,
  FiFileText,
  FiBookOpen,
  FiLayers,
  FiAward,
  FiStar,
  FiTrendingUp,
  FiCheckCircle,
  FiXCircle,
  FiAlertCircle,
  FiDollarSign,
  FiEye,
  FiEdit2,
  FiTrash2,
  FiPlus,
  FiSearch,
  FiFilter
} from "react-icons/fi";
import { 
  MdOutlineVideoLibrary, 
  MdOutlinePerson,
  MdOutlineCategory,
  MdOutlineCalendarToday,
  MdOutlineAccessTime,
  MdOutlinePeople,
  MdOutlineRefresh,
  MdOutlineDescription,
  MdOutlineBook,
  MdOutlineLayers,
  MdOutlineAward,
  MdOutlineStar,
  MdOutlineAttachMoney,
  MdOutlineVisibility,
  MdOutlineEdit,
  MdOutlineDelete
} from "react-icons/md";
import { IoVideocamOutline } from 'react-icons/io5'
import ViewSubTable from './Table/ViewSubTable'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { disableSubscriptionUser, getPlanDataForAdmin, subscribedUserList } from '../../Redux/teacherSubscriptionSlice'
import moment from 'moment'
import SimpleDeleteModal from '../../components/Delete Modal/SimpleDeleteModal'
import { toast } from 'react-toastify'

const ViewSubscription = () => {
    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [deleteItem, setDeleteItem] = useState(false)
    const [isRefresh, setIsRefresh] = useState(false)

    const { id } = useParams();
    const dispatch = useDispatch();
    const selector = useSelector((state) => state)
    const { teachersSubscription: { getPlanDataForAdminData = {}, subscribedUserListData = [], subscribedUserListTotal = [] } } = selector ? selector : {}

    const [keyword, setKeyword] = useState('')
    const [pageNo, setpageNo] = useState(1)
    const [size, setSize] = useState(5)

    let handlePageClick = (newPage) => {
        setpageNo(newPage?.selected + 1)
    }

    let payload = {
        "pageNo": pageNo,
        "size": size,
        "keyWord": keyword ? keyword : ""
    }

    useEffect(() => {
        dispatch(getPlanDataForAdmin({ id: id }))
        dispatch(subscribedUserList({ planId: id }))
    }, [dispatch, id, isRefresh])

    const deleteAction = (data) => {
        setIsDeleteModal(true)
        setDeleteItem(data)
    }

    const handleDelete = async () => {
        try {
            const res = await dispatch(disableSubscriptionUser({ id: deleteItem?._id })).unwrap()
            toast.success(res?.message || "Deleted Successful")
            setIsDeleteModal(false)
            setIsRefresh(() => !isRefresh)
        } catch (error) {
            toast.success(error?.message || error || "Something went wrong")
        }
    }

    const deleteAction1 = async (data) => {
        try {
            let togglePayload = {
                id: data?._id
            }
            const res = await dispatch(disableSubscriptionUser(togglePayload)).unwrap();
            toast.success(res?.message || "Status Updated")
            setIsRefresh(!isRefresh)
        } catch (error) {
            toast.error(error.message || "Something went wrong")
        }
    };

    // Helper function to render info row
    const InfoRow = ({ icon: Icon, label, value, color = "text-gray-800" }) => (
        <div className="grid grid-cols-2 gap-2 py-2 border-b border-gray-100 last:border-0">
            <div className="flex items-center gap-2">
                {Icon && <Icon className="w-4 h-4 text-[#715EFE]" />}
                <span className="font-medium text-gray-600">{label}</span>
            </div>
            <div className={`${color} break-all text-wrap`}>
                {value || "-"}
            </div>
        </div>
    );

    return (
        <div className="min-h-screen bg-gray-50/80">
            {/* Header Banner */}
            <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
                <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
                <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
                <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
                
                <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                        <div className="flex items-center gap-3">
                            <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                                <MdOutlineVideoLibrary className="w-5 h-5 text-white md:w-6 md:h-6" />
                            </div>
                            <div>
                                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                                    Subscription Details
                                </h2>
                                <p className="text-sm text-white/70 hidden sm:block">
                                    View subscription plan information
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                                <span className="text-xs text-white/80">
                                    {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
                {/* Plan Details Cards */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 mb-6">
                    {/* Video Card */}
                    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
                        <div className="p-4 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white flex items-center gap-3">
                            <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
                                <IoVideocamOutline className="w-4 h-4 text-[#715EFE]" />
                            </div>
                            <h3 className="text-sm font-semibold text-gray-700">Video Preview</h3>
                        </div>
                        <div className="p-4">
                            <video
                                controls
                                poster={getPlanDataForAdminData?.thumbUrl}
                                className="w-full h-[250px] md:h-[350px] object-contain rounded-lg bg-black"
                                src={getPlanDataForAdminData?.mediaUrl}
                                onContextMenu={(e) => e.preventDefault()}
                                disablePictureInPicture
                                controlsList="nodownload noplaybackrate"
                            >
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>

                    {/* Information Card */}
                    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
                        <div className="p-4 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white flex items-center gap-3">
                            <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
                                <FiFileText className="w-4 h-4 text-[#715EFE]" />
                            </div>
                            <h3 className="text-sm font-semibold text-gray-700">Subscription Information</h3>
                        </div>
                        <div className="p-4 space-y-1">
                            <InfoRow 
                                icon={FiTag} 
                                label="Title" 
                                value={getPlanDataForAdminData?.title}
                            />
                            <InfoRow 
                                icon={FiFileText} 
                                label="Description" 
                                value={getPlanDataForAdminData?.desc}
                            />
                            <InfoRow 
                                icon={FiBookOpen} 
                                label="Course" 
                                value={getPlanDataForAdminData?.isAllCourse ? "Apply for all courses" : "Only for selected courses"}
                            />
                            <InfoRow 
                                icon={FiLayers} 
                                label="Batches" 
                                value={getPlanDataForAdminData?.isAllBatch ? "Apply for all batches" : "Only for selected batches"}
                            />
                            <InfoRow 
                                icon={FiCalendar} 
                                label="Created Date" 
                                value={moment(getPlanDataForAdminData?.createdAt).format('MMMM D, YYYY')}
                            />
                            <InfoRow 
                                icon={FiUser} 
                                label="Created By" 
                                value={
                                    <div className="flex items-center gap-3">
                                        
                                        <img
                                            src={getPlanDataForAdminData?.createdBy?.profileImage || "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?semt=ais_hybrid&w=740&q=80"}
                                            alt="User"
                                            className="h-8 w-8 rounded-full object-cover border-2 border-gray-200"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.parentElement.innerHTML = `<span class="text-xs font-bold text-[#715EFE]">${getPlanDataForAdminData?.createdBy?.fullName?.charAt(0)?.toUpperCase() || 'U'}</span>`;
                                            }}
                                        />
                                        <span className="font-medium">{getPlanDataForAdminData?.createdBy?.fullName}</span>
                                    </div>
                                }
                            />
                        </div>
                    </div>
                </div>

                {/* Subscribed Users Table */}
                <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
                    <div className="p-0">
                        <ViewSubTable
                            TableName={`Subscribed List`}
                            TableHeader={['#', 'User', 'Amount', 'Create', 'Expire At', 'Action']}
                            TableData={subscribedUserListData}
                            handleToggle={deleteAction1}
                            deleteAction={deleteAction1}
                            keyword={keyword}
                            setKeyword={setKeyword}
                            pageNo={pageNo}
                            setpageNo={setpageNo}
                            size={size}
                            total={subscribedUserListTotal}
                            setSize={setSize}
                            handlePageClick={handlePageClick}
                        />
                    </div>
                </div>
            </section>

            {/* Delete Modal */}
            {isDeleteModal && (
                <SimpleDeleteModal
                    isOpen={isDeleteModal}
                    title={`Delete`}
                    onCancel={() => setIsDeleteModal(false)}
                    onDelete={handleDelete}
                />
            )}
        </div>
    )
}

export default ViewSubscription